import React from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { AdSense } from '../AdSense';

interface MainLayoutProps {
  children: React.ReactNode;
  currentLanguage: string;
  onLanguageChange: (lang: string) => void;
}

export function MainLayout({
  children,
  currentLanguage,
  onLanguageChange,
}: MainLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-[radial-gradient(circle_at_top_left,rgba(37,99,235,0.08),transparent_32rem),linear-gradient(180deg,#ffffff_0%,#f8fbff_46%,#ffffff_100%)] text-slate-950">
      <AdSense
        enabled={import.meta.env.VITE_ADSENSE_ENABLED === 'true'}
        clientId={import.meta.env.VITE_ADSENSE_CLIENT_ID}
      />
      <header>
        <Navbar
          currentLanguage={currentLanguage}
          onLanguageChange={onLanguageChange}
        />
      </header>
      <main id="main-content" className="flex-1" role="main">
        {children}
      </main>
      <footer>
        <Footer
          currentLanguage={currentLanguage}
          onLanguageChange={onLanguageChange}
        />
      </footer>
    </div>
  );
}
